var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 96,
    viewBox: "0 0 295 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0173 55.6147H40.2953C37.3326 55.6147 34.9308 57.9567 34.9308 60.8456V97.5417C34.9308 100.431 37.3326 102.773 40.2953 102.773H50.0173C52.98 102.773 55.3818 100.431 55.3818 97.5417V60.8456C55.3818 57.9567 52.98 55.6147 50.0173 55.6147Z",
    fill: "#C2C5C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8152 38.5596H43.5266V177.287H46.8152V38.5596Z",
    fill: "#C2C5C5",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2563 23.3484H74.5344C71.5716 23.3484 69.1698 25.6903 69.1698 28.5792V179.552C69.1698 182.441 71.5716 184.783 74.5344 184.783H84.2563C87.2191 184.783 89.6209 182.441 89.6209 179.552V28.5792C89.6209 25.6903 87.2191 23.3484 84.2563 23.3484Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0302 3.44727H77.7416V204.424H81.0302V3.44727Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.487 27.5173H108.765C105.803 27.5173 103.401 29.8593 103.401 32.7482V132.335C103.401 135.224 105.803 137.566 108.765 137.566H118.487C121.45 137.566 123.852 135.224 123.852 132.335V32.7482C123.852 29.8593 121.45 27.5173 118.487 27.5173Z",
    fill: "#C2C5C5",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.253 13.8687H111.965V157.266H115.253V13.8687Z",
    fill: "#C2C5C5",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.702 66.458H142.98C140.018 66.458 137.616 68.7999 137.616 71.6889V77.8015C137.616 80.6905 140.018 83.0324 142.98 83.0324H152.702C155.665 83.0324 158.067 80.6905 158.067 77.8015V71.6889C158.067 68.7999 155.665 66.458 152.702 66.458Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.492 0H146.204V99.9673H149.492V0Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.949 64.3936H177.227C174.265 64.3936 171.863 66.7355 171.863 69.6244V72.5906C171.863 75.4795 174.265 77.8214 177.227 77.8214H186.949C189.912 77.8214 192.314 75.4795 192.314 72.5906V69.6244C192.314 66.7355 189.912 64.3936 186.949 64.3936Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.715 15.0312H180.427V91.5299H183.715V15.0312Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M252.177 50.5444H248.889V211.578H252.177V50.5444Z",
    fill: "#C2C5C5",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.173 91.5498H211.451C208.488 91.5498 206.086 93.8917 206.086 96.7806V115.279C206.086 118.168 208.488 120.51 211.451 120.51H221.173C224.135 120.51 226.537 118.168 226.537 115.279V96.7806C226.537 93.8917 224.135 91.5498 221.173 91.5498Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.962 64.4736H214.674V133.838H217.962V64.4736Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5683 84.2349H9.27966V153.599H12.5683V84.2349Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.634 36.2949H279.912C276.95 36.2949 274.548 38.6369 274.548 41.5258V65.3352C274.548 68.2241 276.95 70.566 279.912 70.566H289.634C292.597 70.566 294.999 68.2241 294.999 65.3352V41.5258C294.999 38.6369 292.597 36.2949 289.634 36.2949Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.408 12.2246H283.12V87.8815H286.408V12.2246Z",
    fill: "#FC6432",
    fillOpacity: 0.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechChart);
export default __webpack_public_path__ + "static/media/tech-chart.d9d635409e9a5aa972846bcbee58aaca.svg";
export { ForwardRef as ReactComponent };